import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import WhatsAppFloat from "./WhatsAppFloat";
import { useEffect } from "react";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen bg-[#050505] text-[#F7F7F7] flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 sm:pt-32 pb-24 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
      <WhatsAppFloat />
    </div>
  );
}
